import { useEffect, useRef } from "react";
import { useSearchEntities } from "src/queries/search/search.query";
import type { SearchEntity } from "src/queries/search/search.types";

export interface UseEntityMentionsReturn {
  entitiesRef: React.RefObject<SearchEntity[]>;
  updateDecorationsRef: React.RefObject<(() => void) | null>;
}

const selectIdentity = (entities: SearchEntity[]) => entities;

export function useEntityMentions(): UseEntityMentionsReturn {
  const entitiesRef = useRef<SearchEntity[]>([]);
  const updateDecorationsRef = useRef<(() => void) | null>(null);

  const { data: entitiesData, isError: entitiesError } = useSearchEntities({
    select: selectIdentity,
  });

  useEffect(() => {
    if (entitiesData) {
      entitiesRef.current = entitiesData;
    } else if (entitiesError) {
      entitiesRef.current = [];
    }

    updateDecorationsRef.current?.();
  }, [entitiesData, entitiesError]);

  return { entitiesRef, updateDecorationsRef };
}
